import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { CurrenciesListWrapper } from './currencies-list/CurrenciesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const currenciesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Currency Management',
    path: '/admin/pages/currencies',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/currencies/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const CurrenciesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='currencies'
          index
          element={
            <>
              <PageTitle breadcrumbs={currenciesBreadcrumbs}>Currencies list</PageTitle>
              <CurrenciesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/currencies/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/currencies' />} />
    </Routes>
  )
}

export default CurrenciesPage
